import React, { useState, useEffect } from 'react';
import { Row, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { postAttendance } from '../../../firebase-config';

const TYPES = ['休暇', '午前休暇', '午後休暇', '代休', '出社'];

function AttendancePage({ employee }) {
    useEffect(() => {
        document.title = "勤怠連絡";
    }, []);

    const [type, setType] = useState('休暇');
    const [date, setDate] = useState('');
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setShowSuccess(false);
        setShowError(false);

        try {
            await postAttendance(
                employee.id,
                employee.legechId,
                employee.slackMemberId,
                type.trim(),
                date,
                note.trim()
            );
            setShowSuccess(true);
            setDate('');
            setNote('');
        } catch (error) {
            setShowError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row>
            <h1>勤怠連絡</h1>

            <Form onSubmit={handleSubmit} className='p-4'>
                <Form.Group className='mb-4'>
                    <Form.Label className='fw-bold'>種別 <span className='text-danger'>*</span></Form.Label>
                    <Form.Select value={type} onChange={e => setType(e.target.value)}>
                        {TYPES.map(v => (
                            <option key={v} value={v}>{v}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold'>日付 <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        type='date'
                        value={date}
                        onChange={e => setDate(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className='mb-4'>
                    <Form.Label className='fw-bold'>備考</Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={3}
                        maxLength={500}
                        value={note}
                        onChange={e => setNote(e.target.value)}
                        placeholder='任意'
                    />
                </Form.Group>

                <div className='d-grid gap-2'>
                    <Button variant='primary' type='submit' size='lg' disabled={loading}>
                        {loading ? '送信中...' : '送信'}
                    </Button>
                    {loading && <Spinner animation='border' variant='dark' className='mx-auto' />}
                </div>
            </Form>

            {showSuccess && <Alert variant='success'>送信しました。</Alert>}
            {showError && <Alert variant='danger'>送信に失敗しました。</Alert>}
        </Row>
    );
}

export default AttendancePage;
